import { BodyLarge } from '../../../../../components/Elements';
import strings from '../../../../../strings/strings.json';
import PrimaryButton from '../../../../../components/buttons/PrimaryButton';
import styled from 'styled-components';
import ArrowRightIcon from 'assets/icons/controls/ArrowRightIcon';
import { breakpoints, sizes } from 'theme';

type StartQuestionnaireCardProps = {
    description: string;
    totalQuestions: number;
    startQuestionnaire: () => void;
};
export default function StartQuestionnaireCard({
    description,
    totalQuestions,
    startQuestionnaire,
}: StartQuestionnaireCardProps): JSX.Element {
    return (
        <>
            <BodyLarge>{description}</BodyLarge>
            <StartButtonContainer>
                <BodyLarge $bold>
                    {totalQuestions} {strings.questionnairePage.questionsNumberLabel}
                </BodyLarge>

                <PrimaryButton
                    title={strings.questionnairePage.startQuestionnaireButton}
                    aria={strings.questionnairePage.startQuestionnaireButtonAria}
                    onClick={startQuestionnaire}
                    icon={<ArrowRightIcon />}
                    iconPositionRight
                />
            </StartButtonContainer>
        </>
    );
}

const StartButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: ${breakpoints.sm}) {
        flex-direction: column;
        align-items: unset;
        gap: ${sizes.spacingMd};
    }
`;
